import styled from "@emotion/styled"
import { get } from "lodash"
import React from "react"
import tw from "twin.macro"
import Caption from "./Caption"
import VideoEmbed from "./VideoEmbed"

const Container = styled.div`
  ${props => props.position === `center` ? tw`mx-auto` : null}
  ${props => props.position === `center` ? `max-width: 640px` : null}
`

const VideoBlock = ({ block }) => {
  const video = get(block, "elements.video.value[0]")
  const playInModal =
    get(block, "elements.play_in_modal.value[0].codename") === "yes"
      ? true
      : false
  const caption = get(block, "elements.caption.value")
  const position = get(block, "elements.position.value[0].codename")

  return (
    <Container position={position}>
      {video && <VideoEmbed video={video} playInModal={playInModal} />}
      {caption && caption.replace(/(<p><br><\/p>|\n|\r)+/, "") ? <Caption text={caption} /> : null}
    </Container>
  )
}

export default VideoBlock
